export const HTTP_STATUS_CODES = {
    UNAUTHORIZED: 401,
    OK: 200,
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    INTERNAL_SERVER: 500,
    NOT_ACCEPTABLE: 406
};
